import { useEffect, useRef, useCallback } from 'react';

// ═══════════════════════════════════════════════════════════════════════════════
// useAutoLogout
// Cierra sesión automáticamente tras `timeoutMs` de inactividad.
// "Inactividad" = sin mousemove, keydown, mousedown, touchstart, scroll, click.
// El timer se reinicia en cada evento. Al expirar llama onLogout() sin aviso.
//
// EVENTO_ACTIVIDAD (17-sep-2026): un médico dictando no toca el teclado ni el
// mouse — está viendo al paciente, que es justo lo que queremos. Para el timer
// de inactividad eso parecía una sesión abandonada, así que el auto-logout se
// convertía en el verdadero límite de grabación. El dictado late por su cuenta
// mientras graba (ver DictadoEscriba → arrancarCronometro) y eso mantiene la
// sesión viva. Grabar ES actividad.
// ═══════════════════════════════════════════════════════════════════════════════

export const EVENTO_ACTIVIDAD = 'innovalab:actividad';

const EVENTS = [
  'mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'click',
  EVENTO_ACTIVIDAD,
];

export function useAutoLogout(onLogout, timeoutMs = 60 * 60 * 1000) {
  const timerRef = useRef(null);

  const reset = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onLogout();
    }, timeoutMs);
  }, [onLogout, timeoutMs]);

  useEffect(() => {
    // Arranca el timer al montar
    reset();

    // Reinicia en cada evento de actividad
    EVENTS.forEach(ev => window.addEventListener(ev, reset, { passive: true }));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      EVENTS.forEach(ev => window.removeEventListener(ev, reset));
    };
  }, [reset]);
}
